/*-----------------------------------------------------------------
- Arena Breadcrumbs trans
-----------------------------------------------------------------*/
export default {
    arena  : 'سفارش‌ها',
    details: 'جزئیات سفارش حمل',
};
